/**
 * @generated SignedSource<<541402315f7a4db5a0890d19303412d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPlannerOptions_account$data = {
  readonly id: number;
  readonly project_custom_select_types: ReadonlyArray<{
    readonly id: number;
    readonly model: any;
    readonly name: string;
    readonly options: ReadonlyArray<{
      readonly id: number;
      readonly name: string;
    }>;
    readonly single_select: boolean;
  }>;
  readonly workstreams: ReadonlyArray<{
    readonly id: number;
  }>;
  readonly " $fragmentType": "ProjectPlannerOptions_account";
};
export type ProjectPlannerOptions_account$key = {
  readonly " $data"?: ProjectPlannerOptions_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPlannerOptions_account">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPlannerOptions_account",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "workstreams",
      "kind": "LinkedField",
      "name": "workstreams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "project_custom_select_types",
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "model": {
              "_eq": "PROJECT"
            }
          }
        }
      ],
      "concreteType": "custom_select_types",
      "kind": "LinkedField",
      "name": "custom_select_types",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "model",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "single_select",
          "storageKey": null
        },
        {
          "alias": "options",
          "args": null,
          "concreteType": "custom_select_options",
          "kind": "LinkedField",
          "name": "custom_select_options",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "custom_select_types(where:{\"model\":{\"_eq\":\"PROJECT\"}})"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};
})();

(node as any).hash = "df82f77e85b957b852caa1da576211ab";

export default node;
